import React from "react";

import { Typography } from "@mui/material";
import ModalContainerModule from "../../../modules/modalContainer";
import { DetailsCardContainer, DetailsColumn, DetailsContainer, DetailsLabel, DetailsRow, DetailsText } from "../../../../constants/component.constants";

export default function ViewOwnerModal(props) {
  return (
    <ModalContainerModule
      size="small"
      cancel={props.closeModal}
      openModal={props.openModal}
      modalTitle={props.ownerToView.type === "Company" ? `${props.ownerToView.name}` : `${props.ownerToView.firstName} ${props.ownerToView.lastName}`}
    >
      <Typography
        id="viewOwnerModal"
        variant="h5"
        component="h5"
        sx={{ marginBottom: 0, paddingBottom: 0, color: "#037171" }}
      >
        Owner's Details
      </Typography>
      <DetailsCardContainer
        sx={{
          boxShadow: 0,
          width: "100%",
          height: "auto",
          padding: 0,
          margin: 0,
        }}
      >
        <DetailsContainer container sx={{ marginTop: 0 }}>
          <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
            <DetailsRow>
              <DetailsLabel>Name: </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.name
                  : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Email:</DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.email
                  : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Mobile Phone (Primary Number): </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.mobilePhone
                  : ""}
              </DetailsText>
            </DetailsRow>

            {props.ownerToView?.officePhone && (
              <DetailsRow>
                <DetailsLabel>Office Phone (Secondary Number): </DetailsLabel>
                <DetailsText>
                  {props.ownerToView
                    ? props?.ownerToView?.officePhone
                    : ""}
                </DetailsText>
              </DetailsRow>
            )}
            
            <DetailsRow>
              <DetailsLabel>Property: </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.property
                  : ""}
              </DetailsText>
            </DetailsRow>

            {props.ownerToView?.contactNote && (
              <DetailsRow>
                <DetailsLabel>Contact Note: </DetailsLabel>
                <DetailsText>
                  {props.ownerToView
                    ? props?.ownerToView?.contactNote
                    : ""}
                </DetailsText>
              </DetailsRow>
            )}

          </DetailsColumn>
          <DetailsColumn sx={{ width: { xs: "100%", lg: "50%" } }}>
            <DetailsRow>
              <DetailsLabel>ID Type: </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.idTypeCd
                  : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>ID Number: </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.idNumber
                  : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Role at this property: </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.roleName
                  : ""}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Permissions: </DetailsLabel>
              <DetailsText>
                {props.ownerToView && props?.ownerToView?.permissions.length > 0
                  ? props?.ownerToView?.permissions
                      ?.map((p) => p.charAt(0).toUpperCase() + p.slice(1))
                      .join(", ")
                  : <span style={{ color: "#FF0050", fontWeight: "bold" }}>NO PERMISSIONS</span>}
              </DetailsText>
            </DetailsRow>

            <DetailsRow>
              <DetailsLabel>Unit (s): </DetailsLabel>
              <DetailsText>
                {props.ownerToView
                  ? props?.ownerToView?.unit
                  : ""}
              </DetailsText>
            </DetailsRow>
          </DetailsColumn>
        </DetailsContainer>
      </DetailsCardContainer>
    </ModalContainerModule>
  );
}
